<form name="basic">
    <button type="button" class="btn btn-secondary"  (click)="openFileDialog()" translate>
        Upload csv file
    </button>
    <input #inputField type="file" accept=".csv" (change)="newBulkFile($event)" style="visibility:hidden;position:absolute; display: none">
</form>
